<form>
    <h2 class="redesign" style="margin-top: 50px;">Daten der/des Verstorbenen</h2>

    <div class="row">
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="inputLastName" type="text" class="inputLastName"
                (keyup)="didChangeBurialFieldWithClass('inputLastName')">
            <label class="active" for="inputLastName">Nachname</label>
        </div>
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="inputName" type="text" class="inputName" (keyup)="didChangeBurialFieldWithClass('inputName')">
            <label class="active" for="inputName">Vorname</label>
        </div>
    </div>

    <div class="row st-gap">
        <div class="input-field col s12">
            <input autocomplete="off" id="inputBirthName" type="text" class="inputBirthName" 
                (keyup)="didChangeBurialFieldWithClass('inputBirthName')">
            <label class="active" for="inputBirthName">Geburtsname</label>
        </div>
        <div class="input-field col s12 l6">
            <select id="inputGender" class="inputGender browser-default" (change)="didChangeBurialFieldWithClass('inputGender', true)">
                <option value="0" selected>Geschlecht w&auml;hlen</option>
                <option value="1">m&auml;nnlich</option>
                <option value="2">weiblich</option>
            </select>
        </div>
    </div>

    <div class="row st-gap">
        <div class="input-field col s12">
            <input autocomplete="off" id="inputStreet" type="text" class="inputStreet"
                (keyup)="didChangeBurialFieldWithClass('inputStreet')">
            <label class="active" for="inputStreet">Straße</label>
        </div>
    </div>
    <div class="row st-gap">
        <div class="input-field col s12 l3">
            <input autocomplete="off" id="inputZip" type="text" class="inputZip"
                (keyup)="didChangeBurialFieldWithClass('inputZip')">
            <label class="active" for="inputZip">PLZ</label>
        </div>
        <div class="input-field col s12 l9">
            <input autocomplete="off" id="inputCity" type="text" class="inputCity"
                (keyup)="didChangeBurialFieldWithClass('inputCity')">
            <label class="active" for="inputCity">Wohnort</label>
        </div>
    </div>

    <div class="row st-gap">
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="inputBirthDate" type="text" placeholder="tt.mm.yyyy" class="inputBirthDate" maxlength="10"
                (keyup)="didChangeBurialFieldWithClass('inputBirthDate')">
            <label id="inputBirthDateLabel" for="inputBirthDate" class="inputBirthDateLabel active">Geburtstag</label>
        </div>
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="inputBirthPlace" type="text" class="inputBirthPlace"
                (keyup)="didChangeBurialFieldWithClass('inputBirthPlace')">
            <label class="active" for="inputBirthPlace">Geburtsort</label>
        </div>
    </div>

    <div class="row st-gap">
        <div class="input-field col s3">
            <input autocomplete="off" id="inputDeathDate" type="text" placeholder="tt.mm.yyyy" class="inputDeathDate" maxlength="10"
                (keyup)="didChangeBurialFieldWithClass('inputDeathDate')">
            <label id="inputDeathDateLabel" for="inputDeathDate" class="inputDeathDateLabel active">Todestag</label>
        </div>
        <div class="input-field col s3" style="width: calc(25% - 20px);">
            <input autocomplete="off" id="inputDeathTime" type="text" placeholder="hh:mm" class="inputDeathTime" maxlength="5"
                (keyup)="didChangeBurialFieldWithClass('inputDeathTime')">
            <label class="active" for="inputDeathTime">Todeszeit</label>
        </div>
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="inputDeathPlace" type="text" class="inputDeathPlace"
                (keyup)="didChangeBurialFieldWithClass('inputDeathPlace')">
            <label class="active" for="inputDeathPlace">Todesort</label>
        </div>
    </div>

    <div class="row st-gap" *ngIf="selectedTab() == 'application'">
        <div class="input-field col s12">
            <input autocomplete="off" id="inputBurialPlace" type="text" class="inputBurialPlace"
                (keyup)="didChangeBurialFieldWithClass('inputBurialPlace')">
            <label class="active" for="inputBurialPlace">Beisetzungsort</label>
        </div>
    </div>

    <div class="row m-col st-gap">
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="registryOffice" type="text" class="registryOffice"
                (keyup)="didChangeBurialFieldWithClass('registryOffice')">
            <label class="active" for="registryOffice">Standesamt</label>
        </div>
        <div id="registryOfficeNumberInput" class="input-field col s12 l6">
            <input autocomplete="off" id="registryOfficeNumber" type="text" class="registryOfficeNumber"
                (keyup)="didChangeBurialFieldWithClass('registryOfficeNumber')">
            <label class="active" for="registryOfficeNumber">Sterbefallbescheinigungsnummer</label>
        </div>
    </div>

 

    <div class="row st-gap">
        <div class="input-field col s12">
            <select id="inputReturnType" class="inputReturnType browser-default"
                (change)="didChangeBurialFieldWithClass('inputReturnType', true)"
                style="margin-top:-10px;margin-bottom:10px;">
                <option value="0" selected>R&uuml;ckf&uuml;hrungsart w&auml;hlen</option>
                <option value="1">Urnenversand</option>
                <option value="2">Abholung durch den Bestatter</option>
                <option value="3">R&uuml;ckf&uuml;hrung mit dem n&auml;chsten Fahrdienst</option>
            </select>
        </div>
    </div>
    <span *ngIf="showInputReturnTime">
        <div class="row">
            <div class="input-field col s6">
                <input autocomplete="off" id="inputReturnDate" type="text" placeholder="tt.mm.yyyy" class="inputReturnDate" maxlength="10"
                    (keyup)="didChangeBurialFieldWithClass('inputReturnDate')">
                <label id="inputReturnDateLabel" for="inputReturnDate"
                    class="inputReturnDateLabel active">{{returnDateLabel}}</label>
            </div>
            <div class="input-field col s6">
                <input autocomplete="off" id="inputReturnTime" type="text" placeholder="hh:mm" class="inputReturnTime" maxlength="5"
                    (keyup)="didChangeBurialFieldWithClass('inputReturnTime')">
                <label class="active" for="inputReturnTime">{{returnTimeLabel}}</label>
            </div>
        </div>
    </span>
    <span *ngIf="showInputReturnAddress">
        <div class="row">
            <div class="input-field col s12">
                <h5>Versandanschrift</h5>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12">
                <input autocomplete="off" id="inputReturnLastName" type="text" class="inputReturnLastName"
                    (keyup)="didChangeBurialFieldWithClass('inputReturnLastName')">
                <label class="active" for="inputReturnLastName">Name</label>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12">
                <input autocomplete="off" id="inputReturnName" type="text" class="inputReturnName"
                    (keyup)="didChangeBurialFieldWithClass('inputReturnName')">
                <label class="active" for="inputReturnName">Zusatz</label>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12">
                <input autocomplete="off" id="inputReturnStreet" type="text" class="inputReturnStreet"
                    (keyup)="didChangeBurialFieldWithClass('inputReturnStreet')">
                <label class="active" for="inputReturnStreet">Straße</label>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s12 l3">
                <input autocomplete="off" id="inputReturnZip" type="text" class="inputReturnZip"
                    (keyup)="didChangeBurialFieldWithClass('inputReturnZip')">
                <label class="active" for="inputReturnZip">PLZ</label>
            </div>
            <div class="input-field col s12 l9">
                <input autocomplete="off" id="inputReturnCity" type="text" class="inputReturnCity"
                    (keyup)="didChangeBurialFieldWithClass('inputReturnCity')">
                <label class="active" for="inputReturnCity">Wohnort</label>
            </div>
        </div>
    </span>
    <div class="row space-between center" style="margin-top: 50px;">
        <h2 class="redesign">Antragsteller/in</h2>

        <div class="input-field row" style="margin: unset;" *ngIf="selectedTab() == 'application'">
            <h2 class="redesign action tooltipped" data-position="top" data-delay="10"
                data-tooltip="Übernahme Bestatterdaten" style="margin-right: 20px;"
                (click)="clientAutoButtonClickedWithType('B')">
                B
            </h2>

            <h2 class="redesign action tooltipped" data-position="top" data-delay="10"
                data-tooltip="Übernahme Verstorbenendaten" (click)="clientAutoButtonClickedWithType('V')">
                V
            </h2>
        </div>
    </div>
    <div class="row st-gap">
        <div class="input-field col s12 l6">
            <select id="inputClientSalutation" class="inputClientSalutation browser-default"
                (change)="didChangeBurialFieldWithClass('inputClientSalutation', true)">
                <option value="0" selected>Anrede w&auml;hlen</option>
                <option value="1">Herr</option>
                <option value="2">Frau</option>
                <option value="3">Familie</option>
                <option value="4">Ordnungsamt</option>
            </select>
        </div>
    </div>
    <div class="row st-gap">
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="inputClientLastName" type="text" class="inputClientLastName"
                (keyup)="didChangeBurialFieldWithClass('inputClientLastName')">
            <label class="active" for="inputClientLastName">Nachname</label>
        </div>
        <div class="input-field col s12 l6">
            <input autocomplete="off" id="inputClientName" type="text" class="inputClientName"
                (keyup)="didChangeBurialFieldWithClass('inputClientName')">
            <label class="active" for="inputClientName">Vorname</label>
        </div>
    </div>
    <div class="row st-gap">
        <div class="input-field col s12">
            <input autocomplete="off" id="inputClientStreet" type="text" class="inputClientStreet"
                (keyup)="didChangeBurialFieldWithClass('inputClientStreet')">
            <label class="active" for="inputClientStreet">Straße</label>
        </div>
    </div>
    <div class="row st-gap">
        <div class="input-field col s12 l3">
            <input autocomplete="off" id="inputClientZip" type="text" class="inputClientZip"
                (keyup)="didChangeBurialFieldWithClass('inputClientZip')">
            <label class="active" for="inputClientZip">PLZ</label>
        </div>
        <div class="input-field col s12 l9">
            <input autocomplete="off" id="inputClientCity" type="text" class="inputClientCity"
                (keyup)="didChangeBurialFieldWithClass('inputClientCity')">
            <label class="active" for="inputClientCity">Wohnort</label>
        </div>
    </div>
    <div class="row st-gap">
        <div class="input-field col s12" style="margin-bottom: 16px;">
            <select id="inputUrnType" class="inputUrnType opts-new browser-default"
                (change)="didChangeBurialFieldWithClass('inputUrnType', true)"
                style="margin-top:-10px;margin-bottom:10px;">
                <option value="0" selected>Urne w&auml;hlen</option>
                <option value="17">Friedwaldurne</option>
                <option value="18">Aschebeutel</option>
                <option value="19">Bio Urne</option>
                <option value="20">Stahlkapsel</option>
                <option value="21">Kohleurne mit Schnur</option>
                <option value="22">Kohleurne ohne Schnur</option>
                <option value="23">Guttenberg Urne</option>
                <option value="24">Eigene Urne</option>
            </select>
        </div>
    </div>
    <div class="row st-gap" *ngIf="selectedTab() == 'application'">
        <div class="input-field col s12">
            <input autocomplete="off" id="inputUrnStyle" type="text" class="inputUrnStyle"
                (keyup)="didChangeBurialFieldWithClass('inputUrnStyle')">
            <label class="active" for="inputUrnStyle">&Uuml;berurne</label>
        </div>
    </div>

    <div class="row st-gap">
        <div class="input-field col s12">
            <textarea id="inputBurialInfo" class="materialize-textarea inputBurialInfo"
                (keyup)="didChangeBurialFieldWithClass('inputBurialInfo')"></textarea>
            <label class="active" for="inputBurialInfo">Sonstiges / Bemerkungen</label>
        </div>
    </div>
   
</form>